import React, { useState, useEffect, useRef } from 'react';
// import { appInsights, reactPlugin } from '../../../appInsights';
// import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { jsonEditorStyles } from '../jsonEditorStyles';
import { cloneDeep } from 'lodash';
import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';
import jsonComponentsConfig from '../../../constants/jsonComponents';
import useComponentUIHook from './useComponentUIHook';
import SessionManagement, { sessionFieldsAreValid } from './sessionManagement';

interface componentProps {
  componentData: any;
  closeGritComponent: any;
  setUnsavedChanges: any;
}

const GenerateConditionalAccessRemediationUI = ({
  componentData,
  closeGritComponent,
  setUnsavedChanges,
}: componentProps) => {
  const configData = jsonComponentsConfig.conditionalAccessRemediation.data;
  const { modifiedData, setModifiedData, checkIfSameIgnoringSubFlows, allClaims } = useComponentUIHook(componentData);
  const [disableSubmit, setDisableSubmit] = useState<boolean>(false);
  const classes = jsonEditorStyles();

  useEffect(() => {
    const _res: boolean = checkIfSameIgnoringSubFlows();
    setDisableSubmit(_res || (!sessionFieldsAreValid(modifiedData)));
    setUnsavedChanges(_res);
  }, [modifiedData]);

  return (
    <div>
      <FormControl required sx={{ m: 1, minWidth: 600 }}>
        {configData.sessionManagement && (
          <SessionManagement
            modifiedData={modifiedData}
            changeHandler={(data: any) => setModifiedData(data)}
            sessionTypes={configData.sessionTypes}
          />
        )}
        <Button
          type="submit"
          fullWidth
          variant="contained"
          sx={{ mt: 3, mb: 2 }}
          onClick={() => {
            closeGritComponent(cloneDeep(modifiedData));
          }}
          disabled={disableSubmit}
        >
          Save
        </Button>
      </FormControl>
    </div>
  );
};

// export default withAITracking(reactPlugin, GenerateWebAuthnAuthenticationUI);
export default GenerateConditionalAccessRemediationUI;
